import useTranslation from 'next-translate/useTranslation';
import { useRouter } from 'next/router';
import { AnimatePresence } from 'framer-motion';
import React, { useEffect } from 'react';

import useStore from '../../store';

import Overlay from '../../components/Overlay';
import Filter from './components/Filter';
import List from './components/List';
import ShareButton from '../../components/ShareButton';

import Biography from '../Biography';
import Breadcrumb from '../Biography/components/Breadcrumb';

import { SearchWrapper } from './Search.style';

const Search = () => {
  const { t } = useTranslation('common');
  const router = useRouter();

  const sortOrder = useStore(state => state.search.sortOrder);
  const sortBy = useStore(state => state.search.sortBy);
  const filter = useStore(state => state.search.filter);

  const biography = useStore(state => state.general.biography);
  const loading = useStore(state => state.general.loadingBiography);
  const updateSelected = useStore(state => state.general.updateSelected);
  const glossary = useStore(state => state.general.glossary);
  const selected = useStore(state => state.general.selected);
  const isOverlayVisible = typeof selected !== 'undefined';

  useEffect(() => {
    const query = window.btoa(JSON.stringify({ sortOrder, sortBy, filter }));
    const opt = { shallow: true };

    router.replace(
      { query: { q: query, ...(selected ? { id: selected } : {}) }, pathname: '/search' },
      undefined,
      opt
    );
  }, [selected, filter, sortBy, sortOrder]);

  useEffect(() => {
    const slug = router.query.id;

    if (slug && typeof slug === 'string') {
      updateSelected(slug, router.locale);
    }
  }, []);

  return (
    <>
      <SearchWrapper>
        <Filter />
        <List />
      </SearchWrapper>

      <AnimatePresence>
        {isOverlayVisible && (
          <Overlay
            onClose={() => updateSelected(undefined)}
            loading={loading || !biography}
            header={
              biography ? (
                <Breadcrumb
                  hasRelatives={(biography.relatives || []).length > 0}
                  hasAnnotations={(biography.annotations || []).length > 0}
                />
              ) : undefined
            }
            buttons={<ShareButton />}
            ariaLabelledBy={
              biography ? t('accessibility.biography.label', { name: biography.name }) : undefined
            }
          >
            {biography && !loading && (
              <Biography
                {...biography}
                glossary={glossary}
                onRouteChange={updateSelected}
                key={selected}
              />
            )}
          </Overlay>
        )}
      </AnimatePresence>
    </>
  );
};

export default React.memo(Search);
